var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card-board h-100",
    attrs: {
      "outlined": "",
      "tile": "",
      "to": _vm.to
    }
  }, [_c('v-layout', {
    staticClass: "h-100 white",
    attrs: {
      "column": "",
      "justify-space-between": _vm.imageBoard
    }
  }, [_c('div', {
    staticClass: "w-100"
  }, [_vm.imageBoard ? _c('div', [_c('v-img', {
    attrs: {
      "aspect-ratio": 280 / 128,
      "contain": "",
      "src": _vm.src
    }
  })], 1) : _vm._e(), _vm.imageBoard ? _c('v-divider', {
    staticClass: "border-light"
  }) : _vm._e(), _c('div', {
    staticClass: "card-board__contents pb-0",
    class: [_vm.imageBoard ? 'min-h-140px min-h-md-160px' : '']
  }, [_c('div', {
    staticClass: "h-34px"
  }, [_vm.chip ? _c('v-chip', {
    attrs: {
      "x-small": "",
      "outlined": "",
      "color": "secondary"
    }
  }, [_c('i', {
    staticClass: "icon icon-award mr-4px"
  }), _c('span', {
    staticClass: "font-size-14"
  }, [_vm._v(_vm._s(_vm.chip))])]) : _vm._e()], 1), _c('div', [_vm.title ? _c('div', {
    staticClass: "tit tit--xxs font-weight-extrabold text-truncate-2"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._t("titleSlot"), _vm.text ? _c('div', {
    class: _vm.imageBoard ? 'txt txt--lg txt--dark text-truncate-2 mt-4px mt-md-10px' : 'txt txt--sm text-truncate-3 mt-4px mt-md-10px'
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._t("textSlot"), _vm.teamName ? _c('div', {
    staticClass: "txt txt--sm text-truncate-3 mt-4px mt-md-10px"
  }, [_vm._v(_vm._s(_vm.teamName))]) : _vm._e()], 2)])], 1), _vm.view || this.$slots['hash'] ? _c('div', {
    staticClass: "card-board__contents",
    class: _vm.imageBoard ? 'pt-12px pt-md-20px' : 'pt-0'
  }, [_vm._t("hash"), _vm.view ? _c('v-layout', {
    staticClass: "mt-4px mt-md-10px",
    attrs: {
      "align-center": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-view mr-4px"
  }), _c('p', {
    staticClass: "txt txt--xs txt--light"
  }, [_vm._v(_vm._s(_vm.view))])]) : _vm._e()], 2) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }